import { render, staticRenderFns } from "./jpc-calendar.vue?vue&type=template&id=20e7c3c1&scoped=true"
import script from "./jpc-calendar.vue?vue&type=script&lang=js"
export * from "./jpc-calendar.vue?vue&type=script&lang=js"
import style0 from "./jpc-calendar.vue?vue&type=style&index=0&id=20e7c3c1&prod&lang=scss"
import style1 from "./jpc-calendar.vue?vue&type=style&index=1&id=20e7c3c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e7c3c1",
  null
  
)

export default component.exports